import React, { createContext, useContext, useState } from 'react';
import ConfirmModal from '../components/Common/ConfirmModal';

const ConfirmContext = createContext();

export const ConfirmProvider = ({ children }) => {
  const [confirmState, setConfirmState] = useState({
    open: false,
    title: '',
    message: '',
    onConfirm: null,
    confirmText: 'Confirm',
    cancelText: 'Cancel',
    confirmColor: 'primary',
    variant: 'warning',
    loading: false
  });

  const confirm = (options) => {
    return new Promise((resolve) => {
      setConfirmState({
        open: true,
        title: options.title || 'Confirm Action',
        message: options.message || 'Are you sure you want to proceed?',
        confirmText: options.confirmText || 'Confirm',
        cancelText: options.cancelText || 'Cancel',
        confirmColor: options.confirmColor || 'primary',
        variant: options.variant || 'warning',
        loading: false,
        onConfirm: () => {
          setConfirmState(prev => ({ ...prev, loading: true }));
          resolve(true);
          setTimeout(() => {
            setConfirmState(prev => ({ ...prev, open: false, loading: false }));
          }, 100);
        },
        onCancel: () => {
          resolve(false);
          setConfirmState(prev => ({ ...prev, open: false }));
        }
      });
    });
  };

  const handleClose = () => {
    if (!confirmState.loading) {
      confirmState.onCancel?.();
    }
  };

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}
      <ConfirmModal
        open={confirmState.open}
        onClose={handleClose}
        onConfirm={confirmState.onConfirm}
        title={confirmState.title}
        message={confirmState.message}
        confirmText={confirmState.confirmText}
        cancelText={confirmState.cancelText}
        confirmColor={confirmState.confirmColor}
        variant={confirmState.variant}
        loading={confirmState.loading}
      />
    </ConfirmContext.Provider>
  );
};

export const useConfirm = () => {
  const context = useContext(ConfirmContext);
  if (!context) {
    throw new Error('useConfirm must be used within a ConfirmProvider');
  }
  return context;
};